module.exports = __webpack_public_path__ + "5e52ce02768804054ceeaf6cff7432a1.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/components/face/cooperation/bg.png
// module id = 992
// module chunks = 3